<template>
  <div>
    <el-row style="margin-top: 20px;">
      <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium">
        <el-form-item label="客户名称：">
          <el-select filterable v-model="searchForm.TC_ID" placeholder="请选择客户" clearable @change="onTcChange">
            <el-option v-for="item in customerList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点：">
          <el-select filterable v-model="searchForm.PROJECT_ID_LIST" placeholder="请选择客户" clearable multiple>
            <el-option v-for="item in projectList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类：">
          <el-select v-model="searchForm.CATALOG_ID_LIST" clearable filterable multiple>
            <el-option v-for="item in catalogList" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品名称：">
          <el-input v-model="searchForm.PRODUCT_NAME" clearable @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="日期范围：">
          <el-date-picker v-model="searchForm.DATE" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" :clearable="false">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="查询类型：">
          <el-select size="medium" filterable v-model="searchForm.查询类型" placeholder="请选择" clearable>
            <el-option v-for="item in 毛利表查询类型" :key="item.Stype" :label="item.NAME" :value="item.Stype"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <tooltip-button :disabled="dateRangeSelected" tipContent="请先选择日期范围" buttonType="primary"
            buttonText="筛选" @click="handleSearch">
          </tooltip-button>
          <el-tooltip class="item" effect="dark" content="请选择日期范围" placement="bottom" :disabled="dateRangeSelected">
            <div style="display: inline-block;">
              <download-excel style="display: inline;" :data="exportData" :fields="exportFields"
                :before-finish="endDownload" :before-generate="exportExcel"
                :name="`客户毛利报表详情-${searchForm.DATE[0]}~${searchForm.DATE[1]}.xls`">
                <el-button type="primary" :disabled="!dateRangeSelected" v-preventReClick plain>
                  导出
                </el-button>
              </download-excel>
            </div>
          </el-tooltip>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" max-height="520" stripe border>
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="项目点" prop="PROJECT_NAME" min-width="100px"></el-table-column>
          <el-table-column label="分类" prop="FC_NAME" min-width="100px"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100px"></el-table-column>
          <el-table-column label="品名" prop="NAME" min-width="100px"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100px"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT" min-width="100px"></el-table-column>
          <el-table-column label="销售数量" prop="SALE_COUNT" min-width="100px"></el-table-column>
          <el-table-column label="销售均价" prop="SALE_PRICE" min-width="100px"></el-table-column>
          <el-table-column label="销售金额" prop="SALE_TOTAL_FEE" min-width="100px"></el-table-column>
          <el-table-column label="出库数量" prop="STOCK_OUT_COUNT" min-width="100px"></el-table-column>
          <el-table-column label="成本均价" prop="STOCK_OUT_PRICE" min-width="100px"></el-table-column>
          <el-table-column label="成本金额" prop="STOCK_OUT_COST" min-width="100px"></el-table-column>
          <el-table-column label="毛利" prop="GROSS_PROFIT" min-width="100px"></el-table-column>
          <el-table-column label="毛利率" prop="GROSS_RATE" min-width="100px"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <div class="pagination_box" style="text-align: right">
        <el-pagination @current-change="queryData(currentPage - 1)" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import { getClassFun } from '@/assets/api/skuManage';
import { haveDSXMDFun, selectProjectFun } from '@/assets/api/sellOrder';

export default {
  data() {
    return {
      毛利表查询类型: this.$util.毛利表查询类型(),
      searchForm: {
        DATE: [],
      },
      tableData: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10,
      titleData: JSON.parse(sessionStorage.getItem('TCGrossProfitDetailTitle')) || {
        TC_ID: null,
        DATE: null,
        TYPE_ID: null,
      },
      catalogList: [],
      exportData: [],
      exportFields: {
        项目点: 'PROJECT_NAME',
        分类: 'FC_NAME',
        品牌: 'BRAND',
        品名: 'NAME',
        规格: 'SPECIFICATION',
        单位: 'TYPE_UNIT',
        销售数量: 'SALE_COUNT',
        销售均价: 'SALE_PRICE',
        销售金额: 'SALE_TOTAL_FEE',
        出库数量: 'STOCK_OUT_COUNT',
        成本均价: 'STOCK_OUT_PRICE',
        成本金额: 'STOCK_OUT_COST',
        毛利: 'GROSS_PROFIT',
        毛利率: 'GROSS_RATE',
      },
      customerList: [],
      projectList: [],
    };
  },
  computed: {
    tcId() {
      return this.titleData.TC_ID;
    },
    dateRange() {
      return this.titleData.DATE;
    },
    typeId() {
      return this.titleData.TYPE_ID;
    },
    dateRangeSelected() {
      return Boolean(this.searchForm.DATE && this.searchForm.DATE[0]);
    },
  },
  mounted() {
    this.queryCatalog();
    this.queryTc();
    if (this.tcId) {
      this.searchForm.TC_ID = this.tcId;
      this.onTcChange();
    }
    if (this.dateRange && this.dateRange[0]) {
      this.searchForm.DATE = [...this.dateRange];
    }
    this.searchForm.CATALOG_ID_LIST.push(this.typeId);
    if (this.searchForm.DATE[0]) {
      this.handleSearch();
    }
  },
  methods: {
    // ----拉取团餐公司
    queryTc() {
      haveDSXMDFun().then((result) => {
        this.customerList = result.length > 0 ? result[0].company : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 筛选
    handleSearch() {
      this.currentPage = 1;
      this.queryData(0);
    },
    // 获取界面数据
    queryData(PAGEINDEX) {
      const params = {
        SERVICE_ID: '15069',
        OTYPE: 15,
        GYS_ID: sessionStorage.getItem('tcId'),
        START_DAY: this.searchForm.DATE[0],
        END_DAY: this.searchForm.DATE[1],
        PAGEINDEX,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.PROJECT_ID_LIST && this.searchForm.PROJECT_ID_LIST[0]) {
        params.PROJECT_ID_LIST = this.searchForm.PROJECT_ID_LIST;
      }
      if (this.searchForm.CATALOG_ID_LIST && this.searchForm.CATALOG_ID_LIST[0]) {
        params.FC_CODE_LIST = [...this.searchForm.CATALOG_ID_LIST];
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.查询类型) {
        params.ORDER_SCALE = this.searchForm.查询类型;
      }
      http.post(params).then((res) => {
        this.tableData = res[0].list;
        this.totalCount = res[0].TOTAL_COUNT;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 导出
    async exportExcel() {
      const params = {
        SERVICE_ID: '15069',
        OTYPE: 16,
        GYS_ID: sessionStorage.getItem('tcId'),
        START_DAY: this.searchForm.DATE[0],
        END_DAY: this.searchForm.DATE[1],
      };
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.PROJECT_ID_LIST && this.searchForm.PROJECT_ID_LIST[0]) {
        params.PROJECT_ID_LIST = this.searchForm.PROJECT_ID_LIST;
      }
      if (this.searchForm.CATALOG_ID_LIST && this.searchForm.CATALOG_ID_LIST[0]) {
        params.FC_CODE_LIST = [...this.searchForm.CATALOG_ID_LIST];
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.查询类型) {
        params.ORDER_SCALE = this.searchForm.查询类型;
      }
      await http.post(params).then((res) => {
        if (res[0].list.length == 0) {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        } else {
          const list = res[0].list;
          let saleCount = 0;
          let saleTotalFee = 0;
          let stockOutCount = 0;
          let stockOutCost = 0;
          let grossProfit = 0;
          let grossRate = '';

          list.forEach((item) => {
            saleCount += Number(item.SALE_COUNT);
            saleTotalFee += Number(item.SALE_TOTAL_FEE);
            stockOutCount += Number(item.STOCK_OUT_COUNT);
            stockOutCost += Number(item.STOCK_OUT_COST);
            grossProfit += Number(item.GROSS_PROFIT);
          });
          grossRate = `${((grossProfit / saleTotalFee) * 100).toFixed(2)}%`;
          const lastRow = {
            PROJECT_NAME: '合计',
            SALE_COUNT: `&nbsp;${saleCount.toFixed(2)}`,
            SALE_TOTAL_FEE: `&nbsp;${saleTotalFee.toFixed(2)}`,
            STOCK_OUT_COUNT: `&nbsp;${stockOutCount.toFixed(2)}`,
            STOCK_OUT_COST: `&nbsp;${stockOutCost.toFixed(2)}`,
            GROSS_PROFIT: `&nbsp;${grossProfit.toFixed(2)}`,
            GROSS_RATE: grossRate,
          };
          list.push(lastRow);
          this.exportData = list;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryCatalog() {
      getClassFun().then((result) => {
        if (result.length !== 0) {
          this.catalogList = result;
        } else {
          this.catalogList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    endDownload() {
      this.exportData = [];
    },
    onTcChange() {
      this.queryProject();
    },
    queryProject() {
      const params = {
        TC_ID: this.searchForm.TC_ID,
      };
      selectProjectFun(params).then((res) => {
        this.projectList = res[0].list;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
  },
};
</script>
<style scoped>
.titleData span {
  display: inline-block;
  margin-right: 10px;
  font-weight: bold;
}

.el-tooltip {
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/tableManage/TCGrossProfitDetail.vue